/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { FeatureFlag } from "~/features/featureFlag/constants";
import { FeatureFlagList } from "~/features/featureFlag/types";
import reportError from "~/utils/reportError";

const enabledValues = ["true", "1", ""]; // allow params without a value

const initFeatureFlags = (searchStr: string): FeatureFlagList => {
  const validFlags = Object.values(FeatureFlag);

  if (validFlags.length === 0) {
    return {} as FeatureFlagList;
  }

  const defaultState: FeatureFlagList = validFlags.reduce((acc, value) => {
    acc[value as unknown as keyof FeatureFlagList] = false;
    return acc;
  }, {} as FeatureFlagList);

  try {
    const search = new URLSearchParams(searchStr);

    return validFlags.reduce(
      (acc, key) => {
        const searchValue = search.get(key);
        acc[key as unknown as keyof FeatureFlagList] = enabledValues.includes(String(searchValue));
        return acc;
      },
      { ...defaultState },
    );
  } catch (e) {
    reportError(e);

    return defaultState;
  }
};

export default initFeatureFlags;
